/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{E8672527-3BF7-4A9D-A500-0F8E47ED5DD6}",
  "sitecoreApiHost": "https://dev-dayross.azurewebsites.net/",
  "jssAppName": "internet",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/internet",
  "graphQLEndpoint": "https://dev-dayross.azurewebsites.net//api/internet?sc_apikey={E8672527-3BF7-4A9D-A500-0F8E47ED5DD6}"
};